module.exports = __webpack_public_path__ + "static/media/fridays.46c9c5d0.mp4";